import LocationsList from './locationsList'

export default LocationsList
